export enum ScoreType {
	FullTime = "FT",
	HalfTime = "HT",
	Overtime = "OT/AP",
}
